<template>
		<div id="img_part1" class="row overflow-hidden" style="display: flex;">
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 p-3" 
			style="display: flex; align-items: center;" 
			>
				<div>
				<h1 class="bMikhak text-success" :class="(windowWidth < 990) ? 'text-center' : ''">
					تدریس خصوصی حضوری و آنلاین
					
					<br/>
					تمامی مقاطع تحصیلی، رشته‌ها و مهارت‌ها
				</h1>
				<p class="text-justify rtl">
در ایزی تیک می‌توانید کلاس مدنظر خود را در تمامی مقاطع تحصیلی، رشته‌های درسی، غیردرسی، مهارتی، هنری، فنی و... مشاهده نموده و مناسب‌ترین روش برای دریافت تدریس خصوصی را انتخاب و رزرو نمایید.
				</p>
				
<!-- *********************************** -->
<div class="row" dir="rtl">
				<div class="col-sm-12 col-md-12 col-lg-5 col-xl-5">
					<a href="/teachers">
						<btn
							type="success"
							text = "مشاهده همه مدرس ها"
							textClass="w-100"
						/>
					</a>
				</div>
				<div class="col-sm-12 col-md-12 col-lg-5 col-xl-5" :class="(windowWidth < 990) ? 'mt-3' : ''">
					<router-link to="/aboutme">
						<btn
							dir="rtl"
							class=""
							type="outline-success"
							text="بیشتر بدانید"
							textClass="text-white w-100"
							style_btn="background-color:#1b60c6;"
							:img="require('../../../assets/img/Arrow_Left.svg')"
						/>
					</router-link>
				</div>
			</div>
<!-- *********************************** -->
				</div>
			</div>
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 p-3">
				<img
					alt="تدریس خصوصی حضوری و آنلاین تمامی مقاطع تحصیلی، رشته‌ها و مهارت‌ها"
					title="تدریس خصوصی حضوری و آنلاین تمامی مقاطع تحصیلی، رشته‌ها و مهارت‌ها"
					class="w-100"
					:src="require('../../../assets/img/Illustration_Home_1.svg')"
				/>
			</div>
		</div>
</template>

	<script>
		import btn from  "../../../UI/button/btn.vue";
		export default {
			name: 'p_home',
			data(){
				return {
					height: "",				}
			},
			components: {
				btn,
			},
			props: [],
			mounted(THIS = this){
				setTimeout(function() {
					THIS.height_img_part1();
				}, 100);
			},
			methods:{
				height_img_part1(){
					let height = "";
					if(this.windowWidth<770){
						height = 'height: 15px;';
					}else{
						height = "height: 34vh; ";
					}
					this.height = height;
				}
			}
		}
	</script>
<style>

</style>
